/**
 * Стадия сделки «рисками» (макет: `.stage .pips`): сколько открытых стадий пройдено.
 *
 * Место и число стадий приходят с сервера — своя карта порядка стадий на клиенте
 * разошлась бы с воронкой при первой перестановке этапов (#103).
 */
export function StagePips({ order, total, name }: { order: number; total: number; name: string }) {
  return (
    <span className="stage">
      {total > 0 && (
        <span className="pips" aria-hidden="true">
          {Array.from({ length: total }, (_, index) => (
            <i key={index} className={index < order ? 'on' : undefined} />
          ))}
        </span>
      )}
      {name}
    </span>
  )
}
